/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Math.Easing.Expo

module.exports = {

    In: require('./In'),
    Out: require('./Out'),
    InOut: require('./InOut')

};



//////////////////
// WEBPACK FOOTER
// ./math/easing/expo/index.js
// module id = 293
// module chunks = 0